export default __webpack_public_path__ + "assets/json/contact-form.json";